import React, { useState, useRef, useEffect } from "react";
import countryList from "../../utils/countryList";

// Converter countryList para formato do PhoneInput
const countries = countryList.map(c => ({
    code: c.code,
    name: c.englishName,
    ddi: `+${c.dialCode}`,
    flag: c.flag
})).sort((a, b) => {
    // Brasil sempre primeiro
    if (a.code === 'BR') return -1;
    if (b.code === 'BR') return 1;
    return a.name.localeCompare(b.name);
});

// MANTER LISTA ANTIGA COMENTADA PARA FALLBACK (caso countryList falhe)
const countriesFallback = [
    { code: 'AF', name: 'Afghanistan', ddi: '+93', flag: '🇦🇫' },
    { code: 'AL', name: 'Albania', ddi: '+355', flag: '🇦🇱' },
    { code: 'AD', name: 'Andorra', ddi: '+376', flag: '🇦🇩' },
    { code: 'AO', name: 'Angola', ddi: '+244', flag: '🇦🇴' },
    { code: 'AR', name: 'Argentina', ddi: '+54', flag: '🇦🇷' },
    { code: 'AM', name: 'Armenia', ddi: '+374', flag: '🇦🇲' },
    { code: 'AU', name: 'Australia', ddi: '+61', flag: '🇦🇺' },
    { code: 'AT', name: 'Austria', ddi: '+43', flag: '🇦🇹' },
    { code: 'AZ', name: 'Azerbaijan', ddi: '+994', flag: '🇦🇿' },
    { code: 'BH', name: 'Bahrain', ddi: '+973', flag: '🇧🇭' },
    { code: 'BD', name: 'Bangladesh', ddi: '+880', flag: '🇧🇩' },
    { code: 'BE', name: 'Belgium', ddi: '+32', flag: '🇧🇪' },
    { code: 'BO', name: 'Bolivia', ddi: '+591', flag: '🇧🇴' },
    { code: 'BA', name: 'Bosnia and Herzegovina', ddi: '+387', flag: '🇧🇦' },
    { code: 'BW', name: 'Botswana', ddi: '+267', flag: '🇧🇼' },
    { code: 'BR', name: 'Brasil', ddi: '+55', flag: '🇧🇷' },
    { code: 'BG', name: 'Bulgaria', ddi: '+359', flag: '🇧🇬' },
    { code: 'CA', name: 'Canada', ddi: '+1', flag: '🇨🇦' },
    { code: 'CL', name: 'Chile', ddi: '+56', flag: '🇨🇱' },
    { code: 'CN', name: 'China', ddi: '+86', flag: '🇨🇳' },
    { code: 'CO', name: 'Colombia', ddi: '+57', flag: '🇨🇴' },
    { code: 'CR', name: 'Costa Rica', ddi: '+506', flag: '🇨🇷' },
    { code: 'HR', name: 'Croatia', ddi: '+385', flag: '🇭🇷' },
    { code: 'CY', name: 'Cyprus', ddi: '+357', flag: '🇨🇾' },
    { code: 'CZ', name: 'Czech Republic', ddi: '+420', flag: '🇨🇿' },
    { code: 'DK', name: 'Denmark', ddi: '+45', flag: '🇩🇰' },
    { code: 'DO', name: 'Dominican Republic', ddi: '+1', flag: '🇩🇴' },
    { code: 'EC', name: 'Ecuador', ddi: '+593', flag: '🇪🇨' },
    { code: 'EG', name: 'Egypt', ddi: '+20', flag: '🇪🇬' },
    { code: 'SV', name: 'El Salvador', ddi: '+503', flag: '🇸🇻' },
    { code: 'EE', name: 'Estonia', ddi: '+372', flag: '🇪🇪' },
    { code: 'FI', name: 'Finland', ddi: '+358', flag: '🇫🇮' },
    { code: 'FR', name: 'France', ddi: '+33', flag: '🇫🇷' },
    { code: 'GE', name: 'Georgia', ddi: '+995', flag: '🇬🇪' },
    { code: 'DE', name: 'Germany', ddi: '+49', flag: '🇩🇪' },
    { code: 'GH', name: 'Ghana', ddi: '+233', flag: '🇬🇭' },
    { code: 'GR', name: 'Greece', ddi: '+30', flag: '🇬🇷' },
    { code: 'GT', name: 'Guatemala', ddi: '+502', flag: '🇬🇹' },
    { code: 'HN', name: 'Honduras', ddi: '+504', flag: '🇭🇳' },
    { code: 'HK', name: 'Hong Kong', ddi: '+852', flag: '🇭🇰' },
    { code: 'HU', name: 'Hungary', ddi: '+36', flag: '🇭🇺' },
    { code: 'IN', name: 'India', ddi: '+91', flag: '🇮🇳' },
    { code: 'ID', name: 'Indonesia', ddi: '+62', flag: '🇮🇩' },
    { code: 'IE', name: 'Ireland', ddi: '+353', flag: '🇮🇪' },
    { code: 'IL', name: 'Israel', ddi: '+972', flag: '🇮🇱' },
    { code: 'IT', name: 'Italy', ddi: '+39', flag: '🇮🇹' },
    { code: 'JP', name: 'Japan', ddi: '+81', flag: '🇯🇵' },
    { code: 'KE', name: 'Kenya', ddi: '+254', flag: '🇰🇪' },
    { code: 'KR', name: 'South Korea', ddi: '+82', flag: '🇰🇷' },
    { code: 'LV', name: 'Latvia', ddi: '+371', flag: '🇱🇻' },
    { code: 'LB', name: 'Lebanon', ddi: '+961', flag: '🇱🇧' },
    { code: 'LT', name: 'Lithuania', ddi: '+370', flag: '🇱🇹' },
    { code: 'LU', name: 'Luxembourg', ddi: '+352', flag: '🇱🇺' },
    { code: 'MY', name: 'Malaysia', ddi: '+60', flag: '🇲🇾' },
    { code: 'MX', name: 'Mexico', ddi: '+52', flag: '🇲🇽' },
    { code: 'MA', name: 'Morocco', ddi: '+212', flag: '🇲🇦' },
    { code: 'NL', name: 'Netherlands', ddi: '+31', flag: '🇳🇱' },
    { code: 'NZ', name: 'New Zealand', ddi: '+64', flag: '🇳🇿' },
    { code: 'NG', name: 'Nigeria', ddi: '+234', flag: '🇳🇬' },
    { code: 'NO', name: 'Norway', ddi: '+47', flag: '🇳🇴' },
    { code: 'PK', name: 'Pakistan', ddi: '+92', flag: '🇵🇰' },
    { code: 'PA', name: 'Panama', ddi: '+507', flag: '🇵🇦' },
    { code: 'PY', name: 'Paraguay', ddi: '+595', flag: '🇵🇾' },
    { code: 'PE', name: 'Peru', ddi: '+51', flag: '🇵🇪' },
    { code: 'PH', name: 'Philippines', ddi: '+63', flag: '🇵🇭' },
    { code: 'PL', name: 'Poland', ddi: '+48', flag: '🇵🇱' },
    { code: 'PT', name: 'Portugal', ddi: '+351', flag: '🇵🇹' },
    { code: 'QA', name: 'Qatar', ddi: '+974', flag: '🇶🇦' },
    { code: 'RO', name: 'Romania', ddi: '+40', flag: '🇷🇴' },
    { code: 'RU', name: 'Russia', ddi: '+7', flag: '🇷🇺' },
    { code: 'SA', name: 'Saudi Arabia', ddi: '+966', flag: '🇸🇦' },
    { code: 'RS', name: 'Serbia', ddi: '+381', flag: '🇷🇸' },
    { code: 'SG', name: 'Singapore', ddi: '+65', flag: '🇸🇬' },
    { code: 'SK', name: 'Slovakia', ddi: '+421', flag: '🇸🇰' },
    { code: 'SI', name: 'Slovenia', ddi: '+386', flag: '🇸🇮' },
    { code: 'ZA', name: 'South Africa', ddi: '+27', flag: '🇿🇦' },
    { code: 'ES', name: 'Spain', ddi: '+34', flag: '🇪🇸' },
    { code: 'SE', name: 'Sweden', ddi: '+46', flag: '🇸🇪' },
    { code: 'CH', name: 'Switzerland', ddi: '+41', flag: '🇨🇭' },
    { code: 'TH', name: 'Thailand', ddi: '+66', flag: '🇹🇭' },
    { code: 'TR', name: 'Turkey', ddi: '+90', flag: '🇹🇷' },
    { code: 'UA', name: 'Ukraine', ddi: '+380', flag: '🇺🇦' },
    { code: 'AE', name: 'United Arab Emirates', ddi: '+971', flag: '🇦🇪' },
    { code: 'GB', name: 'United Kingdom', ddi: '+44', flag: '🇬🇧' },
    { code: 'US', name: 'United States', ddi: '+1', flag: '🇺🇸' },
    { code: 'UY', name: 'Uruguay', ddi: '+598', flag: '🇺🇾' },
    { code: 'VE', name: 'Venezuela', ddi: '+58', flag: '🇻🇪' },
    { code: 'VN', name: 'Vietnam', ddi: '+84', flag: '🇻🇳' }
];

// Se conversão falhar, usar fallback
const countriesData = countries.length > 0 ? countries : countriesFallback;


type Country = typeof countries[number];

function maskPhone(phone: string, countryCode: string) {
    const clean = phone.replace(/\D/g, "");
    if (countryCode === "BR") {
        if (clean.length > 10)
            return `(${clean.slice(0, 2)}) ${clean.slice(2, 7)}-${clean.slice(7, 11)}`;
        if (clean.length > 6)
            return `(${clean.slice(0, 2)}) ${clean.slice(2, 6)}-${clean.slice(6, 10)}`;
        if (clean.length > 2) return `(${clean.slice(0, 2)}) ${clean.slice(2)}`;
        if (clean.length > 0) return `(${clean}`;
        return "";
    }
    return clean;
}

interface PhoneInputProps {
    value?: string;
    onChange: (fullPhone: string) => void;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    defaultCountry?: string; // ex: "BR"
    countryCode?: string; // Controle externo do país (sincroniza com select principal)
    id?: string;
}

const PhoneInput: React.FC<PhoneInputProps> = ({
    value = "",
    onChange,
    onBlur,
    disabled,
    defaultCountry = "BR",
    countryCode, // Prop para sincronização externa
    id,
}) => {
    // Detectar país inicial: valor > defaultCountry > Brasil
    function getInitialCountry(val: string) {
        // Busca pelo DDI no value, se existir
        const digits = val.replace(/\D/g, "");
        let found: Country | undefined;
        for (const c of countriesData) {
            if (digits.startsWith(c.ddi.replace("+", ""))) {
                found = c;
                break;
            }
        }
        if (found) return found;
        // Busca pelo código defaultCountry
        found = countriesData.find((c) => c.code === defaultCountry);
        if (found) return found;
        // fallback BR
        return countriesData[0];
    }

    // ESTADO INICIAL
    const initialCountry = getInitialCountry(value);
    const [selectedCountry, setSelectedCountry] = useState<Country>(initialCountry);
    const [isOpen, setIsOpen] = useState(false);
    const [search, setSearch] = useState("");
    const [number, setNumber] = useState<string>(() => {
        let digits = value.replace(/\D/g, "");
        if (digits.startsWith(initialCountry.ddi.replace("+", ""))) {
            digits = digits.slice(initialCountry.ddi.length - 1);
        }
        return digits;
    });

    // Ref para evitar loops infinitos no onChange (inicializa com o valor inicial)
    const lastSentValue = useRef<string>(value || `${initialCountry.ddi}`);

    // SYNC com countryCode externo (quando select principal muda)
    useEffect(() => {
        if (countryCode && countryCode !== selectedCountry.code) {
            const found = countriesData.find(c => c.code === countryCode);
            if (found) {
                setSelectedCountry(found);
            }
        }
        // eslint-disable-next-line
    }, [countryCode]);

    // SYNC DO VALUE EXTERNO SEM LOOP
    useEffect(() => {
        // Não sincroniza se o value é o mesmo que acabamos de enviar
        if (value && value !== lastSentValue.current) {
            let digits = value.replace(/\D/g, "");
            let foundCountry = selectedCountry;

            for (const c of countriesData) {
                if (digits.startsWith(c.ddi.replace("+", ""))) {
                    foundCountry = c;
                    digits = digits.slice(c.ddi.length - 1);
                    break;
                }
            }

            // Só muda se for diferente!
            if (foundCountry.code !== selectedCountry.code) {
                setSelectedCountry(foundCountry);
            }
            if (digits !== number) {
                setNumber(digits);
            }
        }
        // eslint-disable-next-line
    }, [value]);

    // Fecha dropdown ao clicar fora
    const ref = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const close = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) {
                setIsOpen(false);
                setSearch(''); // Limpa busca ao fechar
            }
        };
        document.addEventListener("mousedown", close);
        return () => document.removeEventListener("mousedown", close);
    }, []);

    // Atualiza valor no formato final (com proteção contra loop)
    useEffect(() => {
        const newValue = `${selectedCountry.ddi}${number}`;
        // Só chama onChange se o valor realmente mudou
        if (newValue !== lastSentValue.current) {
            lastSentValue.current = newValue;
            onChange(newValue);
        }
        // eslint-disable-next-line
    }, [selectedCountry, number]);

    function handleSelectCountry(c: Country) {
        if (c.code !== selectedCountry.code) {
            setSelectedCountry(c);
        }
        setIsOpen(false);
        setSearch(''); // Limpa busca ao selecionar
    }

    function handleInputChange(e: React.ChangeEvent<HTMLInputElement>) {
        const val = e.target.value.replace(/\D/g, "");
        setNumber(val);
    }

    return (
        <div
            ref={ref}
            className="flex items-center w-full h-11 rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm shadow-theme-xs focus-within:border-brand-300 focus-within:ring-3 focus-within:ring-brand-500/20 relative"
        >
            <button
                className="flex items-center mr-0 outline-none"
                type="button"
                disabled={disabled}
                onClick={() => setIsOpen((v) => !v)}
                tabIndex={-1}
            >
                <span className="mr-1">{selectedCountry.flag}</span>
                <span className="font-medium">{selectedCountry.ddi}</span>
                <svg width={16} height={16} className="ml-1">
                    <path d="M4 6l4 4 4-4" stroke="#666" strokeWidth={2} fill="none" />
                </svg>
            </button>
            <span className="border-l border-gray-200 h-11 mx-3"></span>
            <input
                id={id}
                type="tel"
                className="flex-1 outline-none bg-transparent text-gray-800 placeholder-gray-400"
                placeholder={
                    selectedCountry.code === "BR" ? "(11) 99123-4567" : "Número do telefone"
                }
                value={maskPhone(number, selectedCountry.code)}
                onChange={handleInputChange}
                onBlur={onBlur}
                disabled={disabled}
                maxLength={selectedCountry.code === "BR" ? 15 : 20}
                inputMode="numeric"
            />
            {isOpen && (
                <div className="absolute top-full left-0 z-10 mt-2 w-full bg-white border rounded-lg shadow-lg max-h-64 overflow-y-auto">
                    <input
                        className="w-full px-3 py-2 border-b outline-none"
                        placeholder="Digite para pesquisar"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        autoFocus
                    />
                    <div>
                        {countriesData
                            .filter(
                                (c) =>
                                    c.name.toLowerCase().includes(search.toLowerCase()) ||
                                    c.ddi.includes(search) ||
                                    c.code.toLowerCase().includes(search.toLowerCase())
                            )
                            .map((c) => (
                                <div
                                    key={c.code}
                                    className="flex items-center px-3 py-2 hover:bg-gray-100 cursor-pointer"
                                    onClick={() => handleSelectCountry(c)}
                                >
                                    <span className="mr-2">{c.flag}</span>
                                    <span className="w-10 font-medium">{c.ddi}</span>
                                    <span>{c.name}</span>
                                </div>
                            ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default PhoneInput;
